'use client'

import Image from 'next/image'
import {SelfContainedNftCardProps} from "@/lib/types";
import React, {useMemo, useState} from "react";
import {detectIPFSMedia, toGatewayUrl} from "@/lib/util";

export default function NftCard({nft, isMetaMaskNft}: SelfContainedNftCardProps) {
    const [videoError, setVideoError] = useState(false);
    const parsedNftData = useMemo(() => {
        const metadata = nft?.metadata;
        if (!metadata?.name) return {
            name: '',
            number: ''
        };
        let name = metadata.name;
        let number = '';
        const symbolIndex = name?.indexOf('#');
        if (symbolIndex !== -1) {
            name = name.substring(0, symbolIndex).trim();
            number = name.substring(symbolIndex + 1).trim();
        }

        return {name, number};
    }, [nft])

    const onVideoError = (err) => {
        setVideoError(true);
    }

    return (
        <div
            key={nft.token_id}
            className="relative border rounded-lg p-4 bg-dark-05 border-grey-02 cursor-pointer min-h-75">
            {isMetaMaskNft && (
                <>
                    <Image
                        className="absolute top-2 left-2 z-10"
                        src='/icons/icon-metamask-2.svg'
                        alt='MetaMask'
                        width={24}
                        height={24}
                    />
                </>
            )}
            {nft?.metadata && (
                <div className="mb-2 relative">
                    {(detectIPFSMedia(nft.metadata?.animation_url || '') || detectIPFSMedia(nft.metadata?.image || '')) ? (
                        <>
                            {!videoError ? (
                                <video
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    preload="metadata"
                                    crossOrigin="anonymous"
                                    className="w-full h-56 object-cover mb-4 rounded"
                                    onError={err => onVideoError(err)}
                                >
                                    <source
                                        src={detectIPFSMedia(nft.metadata.animation_url || '')
                                            ? toGatewayUrl(nft.metadata.animation_url!)
                                            : toGatewayUrl(nft.metadata.image!)}
                                    />
                                </video>
                            ) : (
                                <Image
                                    unoptimized
                                    src={detectIPFSMedia(nft.metadata.animation_url || '')
                                        ? toGatewayUrl(nft.metadata.animation_url!)!
                                        : toGatewayUrl(nft.metadata.image!)!}
                                    alt={nft.metadata?.name || 'NFT'}
                                    width={500}
                                    height={500}
                                    className="w-full h-56 object-contain rounded mb-4"
                                />
                            )}
                        </>
                    ) : (
                        <>
                            {nft.metadata?.animation_url && (
                                <video
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    preload="metadata"
                                    crossOrigin="anonymous"
                                    className="w-full h-56 object-cover mb-4 rounded"
                                >
                                    <source src={nft.metadata.animation_url} type="video/mp4"/>
                                </video>
                            )}
                            {!nft.metadata?.animation_url && nft.metadata?.image && (
                                <Image
                                    unoptimized
                                    src={nft.metadata.image}
                                    alt={nft.metadata?.name || 'NFT'}
                                    width={500}
                                    height={500}
                                    className="w-full h-56 object-contain rounded mb-4"
                                />
                            )}
                        </>
                    )}
                    {parsedNftData.number && (
                        <div className="bg-gold  rounded-sm px-1 absolute bottom-0 right-2 flex">
                            <div className="w-2.5 h-4 relative mr-0.5">
                                <Image
                                    className="mt-1.5"
                                    src='/icons/icon-number.svg'
                                    alt='MetaMask'
                                    width={10}
                                    height={10}
                                />
                            </div>
                            <p
                                className="font-neutra text-[15px] text-dark-06 uppercase">
                                {parsedNftData.number}
                            </p>
                        </div>
                    )}
                </div>
            )}
            {parsedNftData.name && (
                <div>
                    <p className="font-neutra text-lg leading-6 text-white uppercase wrap-break-word">
                        {parsedNftData.name}
                    </p>
                </div>
            )}
        </div>
    )
}